import { styled } from "../stitches.config";

export const SideBar = styled("div", {
  width: "20%",
  "@bp1":{
    order: 1,
    width:"100%"
  }
});
